/* eslint-disable */

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref } from 'firebase/storage';
import { getAnalytics, logEvent } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjGGaUeuC1XpJJRGyOKUhNznTR9NpVEoo",
  authDomain: "self-gens.firebaseapp.com",
  projectId: "self-gens",
  storageBucket: "self-gens.appspot.com",
  messagingSenderId: "221925155924",
  appId: "1:221925155924:web:2487f104d8228957d0f9c1",
  measurementId: "G-1QQ45BH6KL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const storageRef = ref(storage);
export const auth = getAuth(app);
export const db = getFirestore();
export const analytics = getAnalytics(app);
export const faLog = (message, params) => {
  logEvent(analytics, message, params);
};
export { storage, storageRef };